module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/gallery8-718833c9ac71c2634e1e0d95cb3cf2d7.jpg";